(function($) {

  var c = {

    init: function(){
      if( $('.filter-list-input').length == 0 ){return false;}
      $(".filter-list-input").keyup( c.filterMenu );
      var target = $( $('.filter-list-input')[0] ).data('target')
      c.updateResultsCount($(target).length)
    },
    updateResultsCount: function(count){
      $("#searchResultsCount").text(count)
    },
    filterMenu: function(e){
      var searchTerm =$(this).val().toUpperCase();
      if(searchTerm.length == 0){
        $( $(this).data("target") ).show();
        return true;
      }
      var searchItems = $( $(this).data("target") );
      var resultsCount = 0
      for (var i = 0; i < searchItems.length; i++) {
        var match = searchItems[i].getAttribute("data-search");
        if (match && match.length > 0) {
          match = match.toUpperCase()
          // const found = searchTerm.every(r=> match.includes(r) >= 0);
          const found = match.includes(searchTerm)
          if (found) {
            $(searchItems[i]).show();
            resultsCount += 1
          } else {
            $(searchItems[i]).hide();
          }
        }
      }
      c.updateResultsCount(resultsCount)
    }

  };

  c.init();

})(jQuery);
